import { Form } from "formik";
import React, { Component } from "react";
import * as yup from "yup";

import { Button2 } from "@/ui2/atoms/Button";
import { cn } from "@/lib/helpers/cn";
import { CustomForm } from "@/component-library/CustomForm";
import { DashboardCard2 } from "@/components/layout/DashboardCard2";
import { EMERGENCY_SCHEMA } from "@/containers/Dashboard/Patient/schema/PatientProfileInfoSchema";
import FormikInput from "@/components/UI/FormikInput";
import FormikInputFormat from "@/components/UI/formikMobileInput";
import Hr from "@/components/UI/Hr";
import { RE_PHONE } from "@/constants/regex";

import { renderTitleWithValue } from "./renderTitleWithValue";
import SubmitControls from "./SubmitControls";

/** Only mobile number format needs to be validated, no required fields */
const VALIDATION_SCHEMA = yup.object().shape({
  emergency_contact_number: yup
    .string()
    .matches(RE_PHONE, "Emergency Contact Number must be a valid US number"),
});

class EmergencyInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      edit: props.edit,
      profileData: props.data,
    };
  }

  toggleEditEmergencyInfo = () => {
    this.setState((ps) => {
      return {
        edit: !ps.edit,
      };
    });
  };

  submitHandler = (formData, action) => {
    let data = { ...formData };

    this.setState((ps) => {
      return {
        edit: !ps.edit,
        profileData: { ...data },
      };
    });
    this.props.submit(data, action, EMERGENCY_SCHEMA);
  };

  renderEmergencyForm = (formikProps) => {
    return (
      <Form style={{ width: "100%" }}>
        <div className="mx-auto px-0">
          <div className="container px-0">
            <div className="row">
              {EMERGENCY_SCHEMA.map((formEl) => {
                return (
                  <div className="col-12 col-lg-6" key={formEl.name}>
                    {formEl.name === "emergency_contact_number" ? (
                      <FormikInputFormat
                        errors={formikProps.errors}
                        formEl={formEl}
                        onChange={async (val) => {
                          await formikProps.setFieldValue("emergency_contact_number", val.value);
                          formikProps.setFieldTouched("emergency_contact_number");
                        }}
                        touched={formikProps.touched}
                        value={formikProps && formikProps.values.emergency_contact_number}
                      />
                    ) : (
                      <FormikInput
                        errors={formikProps.errors}
                        formEl={formEl}
                        touched={formikProps.touched}
                      />
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
        <div className="mb-3 d-lg-none">
          <Hr />
        </div>
        <SubmitControls cancelHandler={this.toggleEditEmergencyInfo} />
      </Form>
    );
  };

  render = () => (
    <DashboardCard2
      Actions={
        <Button2
          className={cn("tw:border-transparent", this.state.edit && "tw:hidden")}
          onPress={this.toggleEditEmergencyInfo}
          size="sm"
          variant="text"
        >
          Edit
        </Button2>
      }
      title="Emergency Contact Information"
    >
      <div className="PatientProfile__basic-info row no-gutters">
        {!this.state.edit &&
          iterableEmergencyInfo(this.state.profileData).map((item) => {
            return (
              <div className="col-12 col-lg-6" key={item.title}>
                {renderTitleWithValue(item.title, item.value)}
              </div>
            );
          })}

        {this.state.edit && (
          <CustomForm
            initialValues={this.state.profileData}
            onSubmit={this.submitHandler}
            render={this.renderEmergencyForm}
            validationSchema={VALIDATION_SCHEMA}
          />
        )}
      </div>
    </DashboardCard2>
  );
}

export default EmergencyInfo;

export const iterableEmergencyInfo = (profileData) => [
  { title: "Emergency Contact Person", value: profileData.emergency_contact_person || "" },
  { title: "Emergency Contact Number", value: profileData.emergency_contact_number || "" },
];
